import { MenuButton } from '@reach/menu-button';
import React from 'react';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  as?:
    | keyof JSX.IntrinsicElements
    | React.ComponentType
    | React.ForwardRefExoticComponent<React.RefAttributes<unknown>>;
};

export const AccountMenuButton: React.FC<Props> = ({
  as,
  children,
  ...props
}) => {
  return (
    <MenuButton as={as} {...props}>
      {children}
    </MenuButton>
  );
};
